import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useCallback} from 'react'

import {useNavigateToComment, usePullRequestBasePath} from '../stores/layout-selectors'
import {addUrlToHistoryStack} from '@github-ui/history'
import {useNavigate} from '@github-ui/use-navigate'

export const useNavigateToThreadComment = (
  thread: Thread,
  onNavigateToDiffComment: () => void,
  commentId?: number | null,
) => {
  const navigateToSelectedComment = useNavigateToComment()
  const basePath = usePullRequestBasePath()
  const navigate = useNavigate()

  const isOutdated = thread.isOutdated || thread.subject?.isOutdated || thread.positioning?.isOutdated || false

  return useCallback(() => {
    if (!commentId) return

    if (isOutdated && thread.originalDiffPathUri) {
      // eslint-disable-next-line no-restricted-syntax
      const url = new URL(thread.originalDiffPathUri)
      url.searchParams.set('new_files_changed', 'true')

      window.location.href = url.toString()
    } else if (navigateToSelectedComment) {
      navigateToSelectedComment(commentId)
      const currentUrl = window.location.pathname + window.location.search
      addUrlToHistoryStack(`${currentUrl}#r${commentId}`)
    } else {
      navigate(`${basePath}/changes#r${commentId}`)
    }
    window.requestAnimationFrame(() => {
      onNavigateToDiffComment()
    })
  }, [
    commentId,
    isOutdated,
    thread.originalDiffPathUri,
    navigateToSelectedComment,
    navigate,
    basePath,
    onNavigateToDiffComment,
  ])
}
